export default "__VITE_ASSET__8w7P4slY__"